import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

const API_BASE_URL = ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL;

/**
 * Texas Hold'em Game Service
 * All Texas poker-specific operations
 */

/**
 * Initialize Texas room state (seats, chips, blinds, etc.)
 * Should be called right after creating a room.
 */
export const initRoom = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/init`, {});
  return response.data;
};

// === Game Flow ===

/**
 * Start a new game round
 */
export const startGame = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/start-game`, {});
  return response.data;
};

/**
 * Deal the flop (3 community cards)
 */
export const dealFlop = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/deal-flop`, {});
  return response.data;
};

/**
 * Deal the turn (4th community card)
 */
export const dealTurn = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/deal-turn`, {});
  return response.data;
};

/**
 * Deal the river (5th community card)
 */
export const dealRiver = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/deal-river`, {});
  return response.data;
};

/**
 * End the current round
 */
export const endRound = async (roomId) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/end-round`, {});
  return response.data;
};

// === Player Actions ===

/**
 * Place a bet
 */
export const placeBet = async (roomId, seatPosition, betAmount) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/place-bet`, {
    seatPosition,
    betAmount,
  });
  return response.data;
};

/**
 * Check (no bet) on your turn
 */
export const check = async (roomId, seatPosition) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/check`, {
    seatPosition,
  });
  return response.data;
};

/**
 * Set seat ready state (lobby)
 */
export const setReady = async (roomId, seatPosition, ready) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/ready`, {
    seatPosition,
    ready,
  });
  return response.data;
};

/**
 * Fold hand
 */
export const fold = async (roomId, seatPosition) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/fold`, {
    seatPosition,
  });
  return response.data;
};

// === Texas-Specific Settings ===

/**
 * Update blind amounts
 */
export const updateBlinds = async (roomId, adminSeat, smallBlind, bigBlind) => {
  const response = await httpClient.patch(`${API_BASE_URL}/api/v0/room/${roomId}/blinds`, {
    adminSeat,
    smallBlind,
    bigBlind,
  });
  return response.data;
};

// === Rewards System ===

/**
 * Request exercise for chip reward
 */
export const requestExercise = async (roomId, seatPosition, exerciseType) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/request-exercise`, {
    seatPosition,
    exerciseType,
  });
  return response.data;
};

/**
 * Approve or reject exercise request
 */
export const approveExercise = async (roomId, exerciseId, approve) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/texas/${roomId}/approve-exercise`, {
    exerciseId,
    approve,
  });
  return response.data;
};
